import { Grid, Heading } from "@planningcenter/doxy-web"
import { MonthViewOverlayStyles } from "./MonthViewStyles"
import { EventLink } from "./EventListing"
import { CalendarEventScroller } from "./List"
import { WideLayout } from "source/shared/Layout"
import { bool, array } from "prop-types"
import moment from "moment"

const GalleryView = ({
  events,
  loadingEvents,
  hasMore,
  loadMore,
  lastDateLoaded,
}) => {
  events.forEach((it) => {
    it.eventDay = moment(it.eventDate).format("YYYY-MM-DD")
  })

  return (
    <WideLayout>
      <MonthViewOverlayStyles />
      <CalendarEventScroller
        loadingMore={loadingEvents}
        {...{ hasMore, loadMore, lastDateLoaded }}
      >
        <div className="mb-2">
          <Grid columns={[1, { md: 2, lg: 3 }]} gap={4}>
            {events.map(
              ({
                id,
                campus,
                name,
                imageUrl,
                fallbackImageUrl,
                schedule,
                eventDay,
                recurring,
                registrationUrl,
                formattedEndsAt,
                formattedStartsAt,
                multiDayEvent,
              }) => (
                <article
                  className="d-b"
                  key={id}
                  style={{
                    borderRadius: "8px",
                    position: "relative",
                  }}
                >
                  <EventLink eventDay={eventDay} eventId={id}>
                    <div className="mb-0">
                      <img
                        loading="lazy"
                        alt={name}
                        src={imageUrl || fallbackImageUrl}
                        style={{
                          aspectRatio: "16 / 9",
                          borderRadius: "8px 8px 0 0",
                          display: "block",
                          objectFit: "cover",
                          minHeight: "157px",
                        }}
                      />
                    </div>
                    <div
                      className="p-2"
                      style={{ position: "relative", zIndex: "2" }}
                    >
                      <Heading
                        level={1}
                        size={4}
                        text={
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              marginBottom: "2px",
                            }}
                          >
                            {name}
                          </div>
                        }
                      />
                      <div
                        className="c-tint1 fs-13"
                        style={{ marginBottom: "2px" }}
                      >
                        <>{formattedStartsAt}</>
                        {multiDayEvent &&
                          formattedEndsAt !== formattedStartsAt && (
                            <> - {formattedEndsAt}</>
                          )}
                        {recurring && <> | Recurring</>}
                        {schedule}
                      </div>
                      {campus && (
                        <Heading
                          color="tint3"
                          level={2}
                          size={5}
                          style={{ marginBottom: "2px" }}
                          text={campus.toUpperCase()}
                        />
                      )}
                      {registrationUrl && (
                        <div className="success-badge badge">
                          Signups available
                        </div>
                      )}
                    </div>
                    <span
                      style={{
                        borderRadius: "8px",
                        boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, .12)",
                        position: "absolute",
                        inset: "0",
                        zIndex: "1",
                      }}
                    />
                  </EventLink>
                </article>
              ),
            )}
          </Grid>
        </div>
      </CalendarEventScroller>
    </WideLayout>
  )
}

GalleryView.propTypes = {
  events: array.isRequired,
  loadingEvents: bool,
}

export default GalleryView
